module.exports = __webpack_public_path__ + "static/media/charity-housing.48242fcd.svg";